import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { of } from 'rxjs';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { Metadata4RefDto, MetadataDto, SelectMetadataRTComponent } from '@gsp-lcm/metadatart-selector';
import { SessionService } from '@ecp-caf/caf-common';
import { CommonComponentUiRTService, SelectorResult } from '@gsp-cmp/ccmp-ui';
import { GspComponent } from '@gsp-cmp/common-component';
import { BsModalService } from '@farris/ui-modal';
import { BizComponentEntity } from '../../domain/entities/biz-component.entity';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { ActualParameter } from '../../domain/entities/actual-parameter';
import { Parameter } from '@ecp-caf/common-structure';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-edit-component-parameter',
  templateUrl: './edit-component-parameter.component.html',
  styleUrls: ['./edit-component-parameter.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class EditComponentParameterComponent implements OnInit, AfterViewInit {
  private defaultProcessComponentIds = ['5863c8a8-e0a7-4137-a8b2-4c05e42b3b73', 'be781ba1-a88b-4bb8-9c88-2e2a27a9226e'];
  @Input() editState: string;
  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<any>();
  @ViewChild('paramlist') paramlist: DatagridComponent;
  @ViewChild('editFooter') editFooter: TemplateRef<any>;
  paramColumns = [];
  location: 'activity' | 'process' | 'autoActivity';

  groupIcon = '<i class="f-icon f-icon-lookup"></i>';
  executionTimingList = new Array();;
  canEdit: boolean;
  @Input()
  curComponent: BizComponentEntity;
  isShowParameters: boolean = true;
  constructor(
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private sessionSrc: SessionService,
    private componentService: CommonComponentUiRTService,
    private modalService: BsModalService,
    private message: MessagerService,
    public cd: ChangeDetectorRef,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }
  ngAfterViewInit(): void {
  }
  ngOnInit() {
    this.paramColumns = [
      { field: 'code', width: 50, title: this.localePipe.transform('component.editComponentParameter.code') },
      { field: 'name', width: 50, title: this.localePipe.transform('component.editComponentParameter.name') },
      {
        field: 'required', width: 50, title: this.localePipe.transform('component.editComponentParameter.required'), formatter: (v, d, i) => {
          if (v) {
            return this.localePipe.transform('component.editComponentParameter.yes');
          } else {
            return this.localePipe.transform('component.editComponentParameter.no');
          }
        }
      },
      {
        field: 'value', width: 100, title: this.localePipe.transform('component.editComponentParameter.value'),
        editor: {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              e.formControl.setValue(e.instance.value ? e.instance.value : '');
              this.showExprHelp(e);
            },
            clear: (e) => {
              console.log('clear', e);
            }
          }
        }
      }
    ];

    // setTimeout(() => {
    //   this.cd.detectChanges();
    // },0 )
  }
  showExprHelp(e: any) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.location === 'activity') {
      for (const variable of this.designerState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Advanced); // 默认打开高级表达式编辑器
    this.expr.addExpressionText(e.instance.value);
    this.expr.buildExpression().then((expressioninfo: string) => {
      e.formControl.setValue(expressioninfo);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  /**
   * 取数构件帮助new
   */
  openComponentSelectorNew(metadataId: string, sessionId: string) {
    this.componentService.openSelector(metadataId, sessionId).subscribe(
      (selectorResult: SelectorResult) => {
        selectorResult.confirmEvent.subscribe(
          (result: GspComponent) => {
            if (result) {
              const component = new BizComponentEntity(result.name, result.id, result.operations[0].code);
              component.id = ProcessDeUtil.GenerateElementId();
              component.actualParameters = this.bindParas(result);
              if (component.metadataId === '7433df25-9260-4c24-86f0-9da3e89450fb' ||
                component.metadataId === 'd0783800-ed60-488c-b053-8806a15947fe' ||
                component.metadataId === 'b89e9b9a-2e2d-4bd0-b354-187219544d34' ||
                component.metadataId === 'a8b8f7a4-49ae-4b7d-88d2-b3772b9d0ae5') {
                component.scopeType = 'ExternalProcess';
              } else {
                component.scopeType = 'DirectStart';
              }
              this.curComponent = component;
              this.cd.detectChanges();
            }
          });
      });
  }
  private bindParas(component: GspComponent): ActualParameter[] {
    let parameters = [];

    if (component.operations[0].parameters && component.operations[0].parameters.length > 0) {
      if (this.defaultProcessComponentIds.indexOf(component.id) > -1) {
        parameters = this.assignParameterValue(component.operations[0].parameters);
      } else {
        parameters = component.operations[0].parameters.map(p => ({ code: p.code, name: p.name, value: '', required: p.code.toLowerCase() ==='wfcontext'? false : p.required }));
      }
    }
    return parameters;
  }
  private assignParameterValue(params: Parameter[]): ActualParameter[] {
    return params.map(p => {
      if (p.code.indexOf('beId') > -1) {
        const v = this.designerState.formalParameterContext.filter(c => c.key.indexOf('metadataId') > -1)[0].key;
        return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"${v}\\")"}`, required: true};
      } else if (p.code.indexOf('nodeId') > -1) {
        const v = this.designerState.formalParameterContext.filter(c => c.key.indexOf('schemaId') > -1)[0].key;
        return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"${v}\\")"}`, required: true };
      } else if (p.code.indexOf('dataId') > -1) {
        return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"dataId\\")"}`, required: true };
      } else if (p.code.indexOf('procInstId') > -1) {
        return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"procInstId\\")"}`, required: true };
      } else {
        return { code: p.code, name: p.name, value: '', required: true };
      }
    });
  }
  componentSelect() {
    const compFactory = this.resolver.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.typeList = 'WebServiceComponent'; // 目前只能根据元数据类型过滤，后续添加标签过滤
    compRef.instance.selectedMetadata.subscribe(($event: Metadata4RefDto) => {
      try {
        const meta: MetadataDto = $event.metadata;
        this.openComponentSelectorNew(meta.id, this.sessionSrc.getUserSessionId());
      } catch {
        console.log('$event', $event);
        throw new Error(this.localePipe.transform('component.editComponentParameter.openComponentFail') + $event);
      }
    });
    const modalConfig = {
      title: this.localePipe.transform('component.editComponentParameter.componentSelection'),
      width: 980,
      height: 548,
      showButtons: false
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }
  paramAfterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    return of(true);
  }
  endCellEdit() {
    if(this.paramlist) {
      this.paramlist.endCellEdit();
    }
  }

  editOK() {
    // 结束构件参数编辑状态
    this.endCellEdit();
    if (this.validator()) {
      this.submitEmitter.emit(this.curComponent);
    }
  }

  editCancel() {
    this.closeEmitter.emit();
  }

  validator(): boolean {
    if (!this.curComponent || !this.curComponent.metadataId || !this.curComponent.methodCode) {
      this.message.info(this.localePipe.transform('component.editComponentParameter.curComponent'));
      return false
    } else if (this.location !== 'autoActivity' && !this.curComponent.executionTime) {
      this.message.info(this.localePipe.transform('component.editComponentParameter.executionTime'));
      return false;
    } else {
      if(this.isShowParameters) {
        let codeList = '';
        for (const param of this.curComponent.actualParameters) {
          if (param.required && !param.value) {
            codeList = codeList + `，${param.code}`;
          }
        }
        if (codeList.length > 0) {
          codeList = codeList.slice(1, codeList.length)
          this.message.info(this.localePipe.transform('component.editComponentParameter.para') + '【' + codeList + this.localePipe.transform('component.editComponentParameter.paraRequired'));
          return false;
        }
      }
    }
    return true;
  }
}
